export const requestWithProgress = (url: string, file: File, headers: Record<string, string>, onProgress?: (loaded: number, total: number)=>void) => {
    return new Promise((resolve: (data:{status:number, json: ()=>string})=>void, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', e => onProgress?.(e.loaded, e.total));
        xhr.addEventListener('load', () => {resolve({ status: xhr.status, json: ()=>JSON.parse(xhr.responseText) })});
        xhr.addEventListener('error', () => {reject(new Error('File upload failed'))});
        xhr.addEventListener('abort', () => {reject(new Error('File upload aborted'))});

        xhr.open('POST', url, true);
        Object.keys(headers).forEach(it=>{
            if( it == 'Content-Length' ){
                return;
            }
            try {
                xhr.setRequestHeader(it, headers[it]);
            } catch(e){

            }  
        });
        xhr.send(file);  
    })
};